
import KakaoHelper from '../../utils/KakaoHelper';
export default {
  props: {
    imageUrl: {
      type: String,
    }
  },
  data() {
    return {
      modalClose: false
    }
  },
  methods: {
    closeBtn() {
      this.$emit('closeModal', this.modalClose)
    },
    // async shareClick() {
    //   //  this.kakaoHelper.initShareLive(this.imageUrl);
    //   // const data = {
    //   //   image : this.imageUrl
    //   // }
    //   const response = await this.$axios.post(this.imageUrl);
    //   console.log(response);
    //   const url = window.URL.createObjectURL(new Blob([response.data]), {type: 'image'})
   
    //   const link = document.createElement('a')
    //   link.href = url
    //   // link.download = '자유마을TV';
    //   link.setAttribute('download', this.imageUrl);
    //   document.body.appendChild(link);
    //   link.click()
    //   window.URL.revokeObjectURL(link);


    // },
  },
  mounted() {
    this.kakaoHelper = new KakaoHelper(Kakao);
  }
}
